import { CompanyType } from 'src/api';
import { type SelectFieldOption } from 'src/types/components';

export const COMPANY_TYPE_LABEL = {
  [CompanyType.Employer]: 'Employer',
  [CompanyType.Peo]: 'PEO',
  [CompanyType.PeoPayrollProvider]: 'PEO Payroll Provider',
} satisfies Record<CompanyType, string>;

export const COMPANY_SEARCH_CATEGORY_MAP = {
  displayName: 'displayName',
  staffEmail: 'staffEmail',
  emailDomain: 'emailDomain',
} as const;

export const COMPANY_SEARCH_CATEGORIES = [
  { label: 'Display Name', value: COMPANY_SEARCH_CATEGORY_MAP.displayName },
  { label: 'Staff Email', value: COMPANY_SEARCH_CATEGORY_MAP.staffEmail },
  { label: 'Email Domain', value: COMPANY_SEARCH_CATEGORY_MAP.emailDomain },
] as const satisfies SelectFieldOption[];
